(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfMedirisIcon', [MedirisIconFn]);
    
    function MedirisIconFn() {
        var directive = {
            link: link,            
            restrict: 'E',
            templateUrl: '/app/global/templates/rf-mediris-icon.html'
        };
        return directive;

        function link(scope, element) {
        }
    }

})();